<template>
    <v-container fluid>
        <v-row class="align-center mb-2">
            <v-col cols="auto">
                <h2 class="text-h6">Commesse</h2>
            </v-col>
            <v-col cols="12" sm="4" md="3">
                <v-text-field v-model="ricerca" label="Cerca per numero, cliente, lotto o cantiere" density="compact"
                    variant="outlined" hide-details clearable prepend-inner-icon="mdi-magnify"
                    @update:model-value="ricercaCambiata" />
            </v-col>
            <v-spacer />
            <v-col v-if="isAdmin" cols="auto">
                <v-btn color="primary" prepend-icon="mdi-plus" @click="apriDialog">Nuova commessa</v-btn>
            </v-col>
        </v-row>

        <v-data-table :headers="headers" :items="lista" :items-per-page="15" density="comfortable">
            <template #[`item.numero`]="{ item }">
                <a href="#" class="text-primary" @click.prevent="vaiDettaglio(item.id)">{{ item.numero }}</a>
            </template>
            <template #[`item.data`]="{ item }">
                {{ formattaData(item.data) }}
            </template>
            <template #[`item.numeroPosizioni`]="{ item }">
                <v-chip size="small" variant="tonal">{{ item.numeroPosizioni }}</v-chip>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="760" :fullscreen="isMobile">
            <v-card>
                <v-card-title>Nuova commessa</v-card-title>
                <v-card-text>
                    <CommessaForm ref="commessaForm" v-model="form" />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialog = false">Annulla</v-btn>
                    <v-btn color="primary" :loading="salvando" @click="salva">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import CommessaForm from "@/components/commesse/CommessaForm.vue";

export default {
    name: "ElencoCommesse",
    components: { CommessaForm },

    data() {
        return {
            ricerca: "",
            timerRicerca: null,
            dialog: false,
            salvando: false,
            form: this.formVuoto(),
            headers: [
                { title: "Numero", key: "numero" },
                { title: "Progressivo", key: "progressivo" },
                { title: "Cliente", key: "cliente" },
                { title: "Cantiere", key: "cantiere" },
                { title: "Comune cantiere", key: "cantiereCitta" },
                { title: "Data", key: "data" },
                { title: "Lotto", key: "lotto" },
                { title: "Posizioni", key: "numeroPosizioni" },
            ],
        };
    },

    computed: {
        isMobile() {
            return this.$vuetify.display.smAndDown;
        },
        lista() {
            return this.$store.getters["commesse/lista"];
        },
        isAdmin() {
            const ruolo = this.$store.getters["user/getRole"];
            return ruolo === "Admin" || ruolo === "SuperAdmin";
        },
    },

    mounted() {
        this.$store.dispatch("commesse/carica");
    },

    methods: {
        formVuoto() {
            const oggi = new Date().toISOString().substring(0, 10);
            return {
                numero: "", cliente: "", data: oggi, lotto: "",
                clienteIndirizzo: "", clienteCap: "", clienteCitta: "", clienteProv: "",
                cantiere: "", cantiereIndirizzo: "", cantiereCap: "", cantiereCitta: "", cantiereProv: "",
                cantiereComuneId: null,
            };
        },

        formattaData(iso) {
            return iso ? new Date(iso).toLocaleDateString("it-IT") : "—";
        },

        ricercaCambiata() {
            clearTimeout(this.timerRicerca);
            this.timerRicerca = setTimeout(() => {
                this.$store.dispatch("commesse/carica", this.ricerca);
            }, 300);
        },

        vaiDettaglio(id) {
            this.$router.push({ path: `/commesse/${id}` });
        },

        apriDialog() {
            this.form = this.formVuoto();
            this.dialog = true;
        },

        async salva() {
            if (!(await this.$refs.commessaForm.validate())) return;
            this.salvando = true;
            try {
                await this.$store.dispatch("commesse/crea", this.form);
                this.dialog = false;
            } catch (error) {
                console.log(error);
            }
            this.salvando = false;
        },
    },
};
</script>
